/* eslint-disable camelcase */
import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import Dialog from '@material-ui/core/Dialog';

import { AppStyles, AppTheme } from '../styles/AppTheme';
import { CustomMessageDialogStyles } from '../styles/CustomStyles';
import { AppConfig } from '../AppConfig';
import { AppButton } from '../common/components/AppButton';
import { CustomDynamicForm } from '../components/CustomDynamicForm';
import { templateDataMap } from '../helpers/template'
import { AdGenHelper } from '../helpers/AdGenHelper';
import { AdPreviewDialog } from './AdPreviewDialog';
import { AppHelper } from '../helpers/AppHelper';
import { UiHelper } from '../common/helpers/UiHelper';


import { Fade, Slide } from '@material-ui/core';
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction='up' ref={ref} {...props} />;
});

const adVideoContentField = {
  condition: { key: 'displayAdType', value: 'VIDEO' },
  key: 'adVideoName',
  linkName: 'adVideo',
  type: 'edit_text',
  label: 'Video (mp4), 1920x1080',
  hint: 'Upload the Video',
  v_required: { value: true, err: 'Upload the Video' },
  v_min: { value: 1, err: 'Invalid Video' },
  v_max: { value: 100, err: 'Invalid Video' },
  documentUpload: true,
  fileSizeLimit: 20000000,
  uploadType: 'media',
  uploadAccept: 'video/mp4',
  uploadExt: 'mp4',
  placement: 'left'
}

const displayAdType = {
  key: 'displayAdType',
  type: 'radio',
  label: 'Type',
  hint: 'Select type',
  v_required: { value: true, err: 'Select ad type' },
  options: [{ key: 'VIDEO', label: 'Video' }, { key: 'IMAGE', label: 'Image' }],
  placement: 'right'
}



export class AdLayoutDialog extends Component {
  constructor(props) {
    super(props)
    this.modifyFormdefAndSetState()
  }

  modifyFieldDef(formDefinition) {
    const tempTemplateKey = [
      'TEMPLATE5',
      'TEMPLATE6',
      'TEMPLATE7',
      'TEMPLATE8',
    ]
    formDefinition.steps[0].fields.forEach((f) => {
      if (f.key === 'template') {
        f.options.forEach(element => {
          element.imageLink = require('../assets/images/adtemplates/' + element.key + '.jpg')
          tempTemplateKey.forEach(item => {
            if (item === element.key) {
              element.orientation = 'horizontal'
            }
          })
        })
      }
      if (f.key === 'bgColour') {
        f.colourPicker = true
        f.label = 'Background Color'
      }
      if (f.key === 'textColour') {
        f.colourPicker = true
        f.label = 'Text Color'
      }
      if (f.key === 'durationSecs') {
        f.placement = 'right'
      }
    })
  }

  getselectedTemplateDataValues(formValues, selectedLayoutTemplate) {
    let templateData = templateDataMap[selectedLayoutTemplate.key]
    templateData = {
      ...templateData,
      logoLink: formValues.logoName,
      bgColour: formValues.bgColour,
      text: formValues.text,
      textColour: formValues.textColour,
      subText: formValues.subtext,
      subTextColour: formValues.textColour,
      heroImageLink: formValues.heroImageName,
      orientation: selectedLayoutTemplate.orientation
    }
    return templateData
  }

  modifyFormdefAndSetState() {
    const formDefinition = JSON.parse(JSON.stringify(this.props.formDefinition))

    // Modify Fields Definition
    this.modifyFieldDef(formDefinition)

    // Set Layout template
    const templateField = formDefinition.steps[0].fields.find(i => i.key === 'template')
    const savedTemplate = templateField.value
    const layoutTemplates = []
    let selectedLayoutTemplate // default template is null in case of CREATE Ad
    templateField.options.forEach(element => {
      layoutTemplates.push(element)
      if (element.key === savedTemplate) {
        selectedLayoutTemplate = element
      }
    })

    // Set IType
    const savedIType = formDefinition.steps[0].fields.find(i => i.key === 'iType').value
    const selectedIType = savedIType || this.props.selectedITypeForCreate

    let showLayoutSelectionView = true
    if (selectedIType === 'UPLOAD' || this.props.formDefinition.formType === 'edit') {
      showLayoutSelectionView = false
    }

    // Set html preview content
    let htmlContent
    if (selectedLayoutTemplate && selectedLayoutTemplate.key) {
      const templateData = this.getselectedTemplateDataValues(formDefinition, selectedLayoutTemplate)
      htmlContent = AdGenHelper.generateHtml(templateData)
    }

    this.state = {
      showLayoutSelectionView: showLayoutSelectionView,
      selectedIType: selectedIType,
      selectedLayoutTemplate: selectedLayoutTemplate,
      layoutTemplates: layoutTemplates,
      formDefinition: formDefinition,
      dialogTitle: this.props.title,
      showPrevButton: false,
      htmlContent: htmlContent ? htmlContent.html : null
    }
  }

  onCloseModal() {
    this.props.onClosed()
  }

  render() {
    return (
      <Dialog
        open={this.props.isOpen}
        aria-labelledby={this.state.dialogTitle}
        fullWidth={AppHelper.fullWidthCondition()}
        fullScreen={AppHelper.fullWidthCondition()}
        TransitionComponent={window.innerWidth < 1024 ? Transition : Fade}
        maxWidth={this.state.showLayoutSelectionView ? 'md' : (this.state.selectedIType === 'UPLOAD' ? 'md' : 'lg')}
        classes={{
          root: css(Styles.root),
          paper: this.state.showLayoutSelectionView ? css(Styles.paperLayoutSelectionUi) : css(Styles.paper)
        }}
      >
        <div className={css([Styles.modalHeader, AppStyles.modalHeader])}>
          <div className={css(Styles.titleContainer)}>
            {this.state.showPrevButton && <span className={css(Styles.prevIcon)}>
              <i className='material-icons-outlined' style={{ fontSize: 18, color: 'black' }}
                onClick={() => this.onPrevButton()}>arrow_back_ios</i>
            </span>}
            <div className={css(Styles.modalTitle)}>{this.state.dialogTitle}</div>
          </div>
          <button className={css(Styles.modalCloseButton)} onClick={this.onCloseModal.bind(this)} disabled={this.state.inProcess}>
            {UiHelper.renderImg({key:'dialogCloseIcon'})}
          </button>
        </div>
        <div className={css(Styles.modalContent)}>
          {this.state.showLayoutSelectionView ? this.getLayoutSelectionUI() : this.showLayoutConfigUI()}
        </div>
      </Dialog>
    );
  }

  showLayoutConfigUI() {
    let titleField = {}
    let durationSecsField = {}
    const formDefinition = JSON.parse(JSON.stringify(this.state.formDefinition))
    formDefinition.steps[0].fields = []
    for (const f of this.state.formDefinition.steps[0].fields) {
      delete f.condition
      if (f.key === 'title') {
        titleField = f
      }
      if (f.key === 'durationSecs') {
        durationSecsField = f
      }
      if (this.state.selectedIType === 'UPLOAD') {
        if (f.key === 'adImageName' || f.key === 'title') {
          if (f.key === 'adImageName') {
            f.imageWidth = 1920
            f.mode = 'fit'
            f.condition = { key: 'displayAdType', value: 'IMAGE' }
          }
          formDefinition.steps[0].fields.push(f)
        }
      } else {
        if (f.key === 'text' || f.key === 'subtext' || f.key === 'bgColour' ||
          f.key === 'textColour' || f.key === 'logoName' || f.key === 'heroImageName') {
          formDefinition.steps[0].fields.push(f)
        }
      }
    }
    if (!(this.state.selectedIType === 'UPLOAD')) {
      formDefinition.steps[0].fields.push(titleField)
    }
    if (this.state.selectedIType === 'UPLOAD') {
      // Only in case of upload Ad, ad new fields to support video ads
      if (formDefinition.formType === 'edit') {
        let isVideoContent = false
        const adImageNamevalue = formDefinition.steps[0].fields.find(i => i.key === 'adImageName').value
        const adImageNameLink = formDefinition.steps[0].fields.find(i => i.key === 'adImageName').link
        if (AppHelper.isVideoContent(adImageNamevalue)) {
          isVideoContent = true
        }
        if (isVideoContent) {
          displayAdType.value = 'VIDEO'
          adVideoContentField.value = adImageNamevalue
          adVideoContentField.link = adImageNameLink
        } else {
          displayAdType.value = 'IMAGE'
        }
        displayAdType.disabled = true
      } else {
        displayAdType.value = 'IMAGE'
        displayAdType.disabled = false
      }
      formDefinition.steps[0].fields.push(displayAdType)
      formDefinition.steps[0].fields.push(durationSecsField)
      formDefinition.steps[0].fields.push(adVideoContentField)

      formDefinition.steps[0].fields.map((x) => {
        if (x.condition && x.condition.value === 'VIDEO' && x.documentUpload) {
          x.fileSizeLimit = 50000000
          x.maxWidthOrHeight = 1920
        }
      })
    }


    let apiState = {}
    if (this.state.selectedIType === 'UPLOAD') {
      apiState = {
        iType: 'UPLOAD'
      }
    } else {
      apiState = {
        template: this.state.selectedLayoutTemplate.key,
        iType: 'CREATE'
      }
    }
    console.log('ADL apiState', apiState)
    console.log('ADL formDefinition', formDefinition)
    console.log('ori', this.state.selectedLayoutTemplate)
    return (
      <div>
        <AdPreviewDialog
          title={'Ad Preview'}
          isOpen={this.state.showAdPreview ? true : false}
          htmlContent={this.state.htmlContent}
          onClosed={() => this.setState({ showAdPreview: undefined })}
          orientation={this.state.selectedLayoutTemplate ? this.state.selectedLayoutTemplate.orientation : null}
        />
        <div className={css(Styles.layoutContainer)}>
          {(this.state.selectedIType === 'CREATE') &&
            <img src={this.state.selectedLayoutTemplate.imageLink}
              className={this.state.selectedLayoutTemplate.orientation ? css(Styles.selectedHorizontalImage)
                : css(Styles.selectedImage)}></img>}
          <CustomDynamicForm
            apiMethod={this.props.apiMethod}
            apiEndPoint={this.props.apiEndPoint}
            uploadLocation={this.props.uploadLocation}
            apiData={{ ...this.props.apiData, ...apiState }}
            formDefinition={formDefinition}
            onClosed={() => {
              () => {
                this.onCloseModal.bind(this)
              }
            }}
            onCompleteAction={(options) => {
              this.props.onCompleteAction()
            }}
            showPreview={this.state.selectedIType === 'UPLOAD' ? null : this.showPreview.bind(this)}
            getPreview={this.getPreview.bind(this)}
            customSubmit={this.props.customSubmit || null}
          />
        </div>
      </div>)
  }

  getPreview(formValues) {
    if (this.state.selectedLayoutTemplate && this.state.selectedLayoutTemplate.key && formValues) {
      console.log('preview html', this.state.selectedLayoutTemplate)
      const templateData = this.getselectedTemplateDataValues(formValues, this.state.selectedLayoutTemplate)
      const htmlContent = AdGenHelper.generateHtml(templateData)
      return htmlContent.html
    }
    return null
  }

  showPreview(htmlContent) {
    this.setState({
      htmlContent: htmlContent,
      showAdPreview: true
    })
  }

  onLayoutSelection(item) {
    this.setState({
      selectedLayoutTemplate: item,
      showLayoutSelectionView: false,
      dialogTitle: 'Design Your Ad',
      showPrevButton: true,
    })
  }

  onPrevButton() {
    this.setState({
      selectedLayoutTemplate: null,
      showLayoutSelectionView: true,
      dialogTitle: this.props.title,
      showPrevButton: false,
      htmlContent: null
    })
  }

  getLayoutSelectionUI() {
    return (
      <div className={css(Styles.layoutSelectionOuterContainer)}>
        <div className={css(Styles.layoutSelectionContainer, Styles.marginBottomZero)}>
          {this.state.layoutTemplates.map((item, index) => {
            console.log('imageLink', item.orientation)
            if (item.key === 'TEMPLATE1' || item.key === 'TEMPLATE2' || item.key === 'TEMPLATE3' || item.key === 'TEMPLATE4') {
              return (<img src={item.imageLink}
                className={item.orientation ? css([Styles.contentHorizontalImage]) : css([Styles.contentImage])}
                onClick={() => this.onLayoutSelection(item)}></img>)
            }
          })}
        </div>
        <div className={css(Styles.layoutSelectionContainer,Styles.marginBottomZero)}>
          {this.state.layoutTemplates.map((item, index) => {
            console.log('imageLink', item.orientation)
            if (item.key === 'TEMPLATE5' || item.key === 'TEMPLATE6') {
              return (<img src={item.imageLink}
                className={item.orientation ? css([Styles.contentHorizontalImage]) : css([Styles.contentImage])}
                onClick={() => this.onLayoutSelection(item)}></img>)
            }
          })}
        </div>
        <div className={css(Styles.layoutSelectionContainer)}>
          {this.state.layoutTemplates.map((item, index) => {
            console.log('imageLink', item.orientation)
            if (item.key === 'TEMPLATE7' || item.key === 'TEMPLATE8') {
              return (<img src={item.imageLink}
                className={item.orientation ? css([Styles.contentHorizontalImage]) : css([Styles.contentImage])}
                onClick={() => this.onLayoutSelection(item)}></img>)
            }
          })}
        </div>
      </div>)
  }
}

const CONTENT_IMAGE_DIMEN = 120
const Styles = AppConfig.CUSTOM_STYLE ? CustomMessageDialogStyles : StyleSheet.create({
  modalHeader: {
    padding: 20,
    paddingLeft: 30,
    paddingRight: 30,
    paddingBottom: 14
  },
  modalTitle: {
    color: 'black',
    fontSize: 26,
    fontWeight: 600
  },
  modalContent: {
    paddingLeft: 25,
    paddingRight: 25,
  },
  modalCloseButton: {
    position: 'absolute',
    top: 23,
    right: 30,
    padding: 0,
    border: 'none',
    backgroundColor: 'transparent',
    display: 'flex',
    outline: 'none',
    cursor: 'pointer',
  },
  modalCloseIcon: {
    width: 18,
    height: 18,
    padding: 1,
    fill: 'black',
    borderRadius: AppTheme.borderRadius
  },
  root: {
    zIndex: 13000,
  },
  paper: {
    borderRadius: AppTheme.borderRadius,
    '@media (max-width: 1024px)': {
      maxHeight: 'calc(100% - 140px) !important',
      borderRadius: '20px 20px 0 0',
      bottom: '0 !important',
      position: 'fixed',
      height: 'auto !important'
    }
  },
  paperLayoutSelectionUi: {
    borderRadius: AppTheme.borderRadius,
    maxWidth: 650,
    '@media (max-width: 1024px)': {
      maxHeight: 'calc(100% - 140px) !important',
      borderRadius: '20px 20px 0 0',
      bottom: '0 !important',
      position: 'fixed',
      height: 'auto !important'
    }
  },
  selectedImage: {
    width: 160,
    height: (1920 / 1080) * 160,
    margin: 20,
    borderRadius: 16,
  },
  contentImage: {
    width: CONTENT_IMAGE_DIMEN,
    height: (1920 / 1080) * CONTENT_IMAGE_DIMEN,
    margin: 10,
    marginRight: 20,
    borderRadius: 16,
  },
  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'flex-end',
    marginTop: 20,
    marginBottom: 30
  },
  layoutContainer: {
    display: 'flex',
    marginTop: 0,
    marginBottom: 0,
    //backgroundColor: 'yellow',
    flexWrap: 'wrap',
    //maxWidth: (180 * 4) + 100
  },
  layoutSelectionContainer: {
    display: 'flex',
    marginTop: 0,
    marginBottom: 30,
    flexWrap: 'wrap',
  },
  prevIcon: {
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'center',
    paddingRight: 5
  },
  titleContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  contentHorizontalImage: {
    width: (1920 / 1080) * CONTENT_IMAGE_DIMEN,
    height: CONTENT_IMAGE_DIMEN,
    margin: 10,
    marginRight: 20,
    borderRadius: 16,
  },
  selectedHorizontalImage: {
    width: (1920 / 1080) * 160,
    height: 160,
    margin: 20,
    borderRadius: 16,
  },
  layoutSelectionOuterContainer: {
    display: 'flex',
    flexDirection: 'column'
  },
  marginBottomZero: {
    marginBottom: 'unset'
  }
})



// WEBPACK FOOTER //
// ./src/components/AdLayoutDialog.js